import React, { useEffect, useState } from 'react';
import { Menu, Flex } from 'antd';
import Icon from '@mdi/react';
import { mdiChartBar, mdiChevronRight, mdiTimelineClock, mdiAccountGroup } from '@mdi/js';
import { useHistory } from 'react-router-dom';
import P from 'router/paths';
import useQueryParams from 'hooks/useQueryParams';
import JourneyReport from 'modules/ReportModule/context/JourneyReport';
import useWorkspace from 'store/redux/hooks/useWorkspace';

const ReportMainMenu = ({ dateRangeComponent }) => {
  const { workspace } = useWorkspace();
  const selected_website_id = localStorage.getItem(`selected_website_id_${workspace.id}`);
  const [selected, setSelected] = useState('traffic_report');

  const history = useHistory();

  const { searchParams, setUrlParams } = useQueryParams();
  const { user_id, website_id = selected_website_id, report } = searchParams;
  const appendQuery = (path) => `${path}?website_id=${website_id}`;

  const items = [
    {
      key: 'traffic_report',
      url: appendQuery(P.REPORT.INDEX),
      icon: <Icon path={mdiChartBar} />,
      label: 'Traffic Report',
    },
    {
      key: 'users',
      url: appendQuery(P.REPORT.USERS),
      icon: <Icon path={mdiAccountGroup} />,
      label: 'Users',
    },
    {
      key: 'journey',
      label: (
        <Flex className='items-center gap-1'>
          <Icon path={mdiTimelineClock} size={0.7} />
          User Journey
          {user_id && selected === 'users' && (
            <>
              <Icon path={mdiChevronRight} size={0.8} />
              <span className='font-semibold'>{user_id}</span>
            </>
          )}
        </Flex>
      ),
    },
  ];

  useEffect(() => {
    const activeKey = user_id && selected === 'users' ? 'journey' : selected;
    setSelected(activeKey);
  }, [user_id, report]);

  const onSelect = ({ key }) => {
    const selectedItem = items.find((item) => item.key === key);

    if (key == 'journey') {
      setUrlParams({ report: 'user_journey' });
      setSelected(key);
    } else {
      if (selectedItem?.url) {
        history.push(selectedItem.url);
        setSelected(key);
      }
    }
  };
  return (
    <div className='flex items-center justify-between gap-2 px-4 pr-8 mt-1 md:mb-0 mb-1 flex-wrap'>
      <Menu
        mode='horizontal'
        className='w-1/2 order-0 sm:order-1 !border-none'
        items={items}
        selectedKeys={[selected]}
        onSelect={onSelect}
      />
      <div className='flex flex-wrap items-center gap-1 mb-2 sm:flex-nowrap order-1 sm:order-0 w-fit sm:mb-0'>
        <JourneyReport
          applyGlobally={true}
          shape='round'
          disableDate={true}
          date_key='trafficReportingOverview'
          headStyle={{ padding: 0, margin: 0, minHeight: 10, border: 'none' }}
        />
        <div className='w-full sm:max-w-44'>{dateRangeComponent}</div>
      </div>
    </div>
  );
};

export default ReportMainMenu;
